import React from 'react';
import {
  Stepper,
  Step,
  StepButton,
  Typography,
} from '@material-ui/core';
import { useLocation, useHistory } from 'react-router-dom';
import { useStepStyles } from '../styles';

const STEPS = {
  '/brands/new': 0,
  '/brands/new/positions': 1,
  '/brands/new/owners': 2,
  '/brands/new/address': 3,
  '/brands/new/checkout': 4,
};

const StepLabel = (props) => {
  const { children, value, index, other } = props;

  return (
    <Typography className={useStepStyles().steplabel}
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {children}
    </Typography>
  );
}

function getSteps() {
  return [
    <StepLabel>Step 1:<br />Brand Image</StepLabel>,
    <StepLabel>Step 2:<br />Brand Position</StepLabel>,
    <StepLabel>Step 3:<br />Owner Info</StepLabel>,
    <StepLabel>Step 4:<br />Brand Address</StepLabel>,
  ];
}

const Steps = () => {
  const location = useLocation();
  const history = useHistory();
  const activeStep = STEPS[location.pathname];
  const stepChange = (index) => {
    if (index < activeStep) {
      history.push(Object.keys(STEPS)[index]);
    }
  };

  return (
    <Stepper alternativeLabel nonLinear activeStep={activeStep} className={useStepStyles().root}>
      {getSteps().map((label, index) => (
        <Step key={index}>
          <StepButton onClick={() => stepChange(index)} completed={index < activeStep}>
            {label}
          </StepButton>
        </Step>
      ))}
    </Stepper>
  );
};

export default Steps;
